import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resources } from './resources'

export type Language = 'no' | 'en'

// Stored in the browser like the theme: the users table is owned upstream, so
// there is nowhere server-side to keep it. Logout does not clear this key.
export const LANGUAGE_STORAGE_KEY = 'language'

function storedLanguage(): Language {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) === 'en' ? 'en' : 'no'
  } catch {
    return 'no'
  }
}

i18n.use(initReactI18next).init({
  resources,
  // Norwegian unless the user has picked English; the browser language is
  // deliberately ignored (#714).
  lng: storedLanguage(),
  fallbackLng: 'no',
  defaultNS: 'common',
  ns: Object.keys(resources.no),
  interpolation: { escapeValue: false }, // React already escapes
  returnNull: false,
})

document.documentElement.lang = i18n.language === 'en' ? 'en' : 'nb'

i18n.on('languageChanged', lng => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng)
  } catch {
    // Private mode etc.: the choice just lasts for this page load.
  }
  document.documentElement.lang = lng === 'en' ? 'en' : 'nb'
})

export function currentLanguage(): Language {
  return i18n.language === 'en' ? 'en' : 'no'
}

export default i18n
